import { getApiUrl } from "@repo/utils/get-api-url";
import type {
  GetDeliveryOptionsParams,
  DeliveryOptionsResponse,
} from "./types";

export type { DeliveryOptionsResponse, GetDeliveryOptionsParams };

export async function getDeliveryOptions({
  requestInstance,
  country,
  lang = "en-GB",
  store = "ts-gb",
  currency = "GBP",
}: GetDeliveryOptionsParams): Promise<DeliveryOptionsResponse> {
  const url = getApiUrl({
    path: `/commerce/deliveryoptions/v2/deliverycountryoptions`,
    searchParams: {
      country,
      lang,
      store,
      currency,
    },
  });

  const response = await requestInstance.get<DeliveryOptionsResponse>(
    url,
    undefined,
    {
      requestType: "DELIVERY_OPTIONS_API",
    },
  );

  return response.data;
}
